import type { WireColor } from '@/api/types/color'
import { createRequiredContext } from './create-required-context'

const { Provider, useRequiredContext } =
  createRequiredContext<ReadonlyMap<number, WireColor>>('ColorPalette')

/**
 * The yb360 color catalog keyed by `colorId`, so the canvas can turn a shape's
 * `fillColorId`/`fillTint` into a color the way legacy does at draw time (`SvgUtil.createSvgFill`).
 * Home computes the map from `useColorsQuery` and provides it here; it is an empty map while
 * the catalog is loading. Throws if called outside `<ColorPaletteProvider>` — a wiring bug.
 */
export { Provider as ColorPaletteProvider }

export function useColorPalette(): ReadonlyMap<number, WireColor> {
  return useRequiredContext()
}
